// extracted by css-extract-rspack-plugin
export default {"gridFrameBottom":"DetailsTemplate-module__gridFrameBottom__V8EMz"};